import { Product } from 'even-ts-static'
import * as React from 'react'

import { DepositsOffer } from 'embed/constants/models'

import DepositsOfferListItem from 'embed/components/DepositsOfferList/list-item'
import ErrorIndicator from 'embed/components/ErrorIndicator'
import LoadingIndicator, { BRAND_COLOR } from 'embed/components/LoadingIndicator'

interface Props {
  offer?: DepositsOffer
  dispatchOfferCta?: (offer: DepositsOffer) => void
  loading: boolean
  error: boolean
  useCompactListItem: boolean
  viewportHeight?: number
  viewportWidth?: number
}

export const SingleOfferView: React.FC<Props> = (props) => {
  if (props.loading) {
    return <LoadingIndicator brandColor={BRAND_COLOR.TRUE} loadingLabel="Finding Offer" product={Product.Deposits} />
  } else {
    if (props.offer) {
      return (
        <div>
          <DepositsOfferListItem
            bestOfferId={props.offer.uuid}
            dispatchOfferCta={props.dispatchOfferCta}
            key={props.offer.uuid}
            offer={props.offer}
            useCompactListItem={props.useCompactListItem}
            viewportHeight={props.viewportHeight}
            viewportWidth={props.viewportWidth}
          />
        </div>
      )
    } else {
      return <ErrorIndicator errorLabel="This offer is no longer available." />
    }
  }
}
